import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, } from '@ngx-translate/core';

import { FavoriteManagerComponent } from './favorite-manager.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        FavoriteManagerComponent
    ],
    exports: [
        FavoriteManagerComponent
    ],
    bootstrap: [],
    providers: [],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class FavoriteManagerModule { }